<template>
  <div class="reg-ate-fav">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else>
      <div class="cabecalho">
        <RF-Filtro-Busca-Telas v-if="Object.keys(filtros).length >= 1" v-show="!cpntStatusImprimir"
          :cpntTime='time'
          :cpntStatus='""'
          :cpntField='filtros'

          :cpntOnRealizaBusca='regAteFavoritosBuscarRegistros'
          :data-time='time'
        ></RF-Filtro-Busca-Telas>
      </div>

      <div v-if="Object.keys(registros).length === 0" style="text-align: center;">
        Nenhum registro encontrado para este contato.
      </div>
      
      <div v-for="(dia, indexD) in registros" :key="'msg-' + indexD">
        <div class="data" v-html="dia.data"></div>

        <div v-for="(msg, indexM) in registros[indexD].mensagens" :key="'msg-' + indexD + '-' + indexM">
          <Registro-Atendimento-Time-Line-Mensagem
            :data-time="time"
            :cpntChave="registros[indexD].mensagens[indexM].time + '--' + registros[indexD].mensagens[indexM].id + '--'"
            :cpntTipo="'recebido'"
            :cpntId="registros[indexD].mensagens[indexM].id"
            :cpntMensagem="registros[indexD].mensagens[indexM].comentario"
            :cpntStatus="registros[indexD].mensagens[indexM].status"
            :cpntLastAt="registros[indexD].mensagens[indexM].last_at"
            :cpntLastUser="registros[indexD].mensagens[indexM].last_user"
            :cpntFiles="registros[indexD].mensagens[indexM].files"
            :cpntInteracao="registros[indexD].mensagens[indexM].icone"
            :cpntFormaContatoId="registros[indexD].mensagens[indexM].id_forma_contato"
            :cpntMsgResposta="registros[indexD].mensagens[indexM]._resposta"

            :cpntFormaConOptions="formaConOptions"
            :cpntSetarFocusMsg="regAteFavoritosAbrirMensagem"
            ></Registro-Atendimento-Time-Line-Mensagem>
        </div>
      </div>
    </template>
  </div>
</template>

<style scoped>
  .reg-ate-fav {
    min-height: 400px;
    width: 400px;
    max-width: 400px;
    margin: 0px auto;
  }
  .reg-ate-fav > div > .data {
    text-align: center;
    width: 100px;
    margin: 0px auto;
    clear: both;

    border: 1px solid #bfd4de;
    background-color: rgba(225,245,254,.92);
    border-radius: 7.5px;
    box-shadow: 0 1px .5px rgba(0,0,0,.13);
    padding: 5px 12px 6px;
    text-align: center;
    text-shadow: 0 1px 0 hsla(0,0%,100%,.4);
  }
  .reg-ate-fav > .cabecalho {
    margin: 0px auto;
    text-align: center;
  }
    .reg-ate-fav > .cabecalho > .rf-tabela-filtro-tela {
      padding-top: 10px;
      padding-bottom: 20px;
      margin: 0px auto;
      float: none;
      display: inline-block;
    }
    .reg-ate-fav > .cabecalho > button {
      margin: 10px;
    }
</style>

<style>
.reg-ate-fav > div > div > .reg-ate-time-line-msg > .celula {
  width: 100% !important;
  max-width: 100% !important;
  cursor: pointer;
}

.reg-ate-fav > .cabecalho > .rf-tabela-filtro-tela > .rf-filtro-tela-usuario {
  width: 200px;
}
</style>

<script>
  export default {
    props: {
      cpntId: {
        required: true,
        type: [ String, Number ]
      },
      cpntStatusImprimir: {
        required: false,
        default: function () {
          return false
        }
      },
      cpntFecharFormulario: {
        required: true
      }
    },
    components: {
      'Registro-Atendimento-Time-Line-Mensagem': () => import('@/components/registro-atendimento/Registro-Atendimento-Time-Line-Mensagem.vue'),
      'RF-Filtro-Busca-Telas': () => import('@/components/rf-geral/busca/RF-Busca-Telas.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        registros: {},
        filtros: {},
        formaConOptions: []
      }
    },
    mounted: function () {
      this.regAteFavoritosIniciar()
    },
    methods: {
      regAteFavoritosIniciar: function () {
        var self = this

        // SETA O STATUS DA TELA
        self.regAteFavoritosSetaStatusGeral('carregando')

        // IMPORTA A FUNÇÃO PARA ATUAIZAR OS DADOS DA API
        const FUN_TRATAR_RETONOS_E_CALLBACK = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_RETONOS_E_CALLBACK

        // EXECUTA A FUNÇÃO DE CALLBACKS
        FUN_TRATAR_RETONOS_E_CALLBACK(self, {
          regAteFavoritosCriarFiltros: [ ],
          regAteFavoritosBuscarRegistros: [ ],
          regAteFavoritosBuscarFormaContato: [ ],
          regAteFavoritosFinalizar: [ 'regAteFavoritosCriarFiltros', 'regAteFavoritosBuscarRegistros', 'regAteFavoritosBuscarFormaContato' ]
        },
        {
          regAteFavoritosCriarFiltros: function (chave, callback, self) { self.regAteFavoritosCriarFiltros(function () { callback(chave) } ) },
          regAteFavoritosBuscarRegistros: function (chave, callback, self) { self.regAteFavoritosBuscarRegistros(function () { callback(chave) } ) },
          regAteFavoritosBuscarFormaContato: function (chave, callback, self) { self.regAteFavoritosBuscarFormaContato(function () { callback(chave) } ) },
          regAteFavoritosFinalizar: function (chave, callback, self) { self.regAteFavoritosFinalizar(function () { callback(chave) } ) },
        })
      },
      regAteFavoritosSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      regAteFavoritosCriarFiltros: function (callback = null) {
        var self = this

        // SETA O CAMPO USUARIO
        self.filtros.usuario = {
          tipo: 'select2',
          status: '',
          tamanho: 57,
          id: 'reg-ate-time-line-favorito-usuario',
          nome: 'Usuário',
          keyValue: 'id',
          keyMostra: [ 'usuario' ],
          value: '',
          searchMinimo: 7,
          options: self.$store.state.usuarios_reg_ate,
          optionInicialNome: 'Todos',
          optionInicialValue: '',
          onChange: function (value) {
            // SETA O VALOR RECEBIDO
            self.filtros.usuario.value = value

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA REINICIAR AS BUSCA
            self.regAteFavoritosBuscarRegistros()
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // EXECUTA A FUNÇÃO CALLBACK
        if (callback !== null) {
          callback()
        }
      },
      regAteFavoritosBuscarFormaContato: function (callback = null, registros = [], total = null) {
        var self = this

        if (total === null || registros.length < total) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, nome: null, icone: null }, where: { f: 'status', o: '=', v: '1' }, order: { nome: 'asc' } }
  
          // FAZ A BUSCA NA API
          self.$store.state.comunicaAPI('/reg-atendimento/config/for-contato/get/', 'GET', queryGet, function (apiSuccess) {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA CARREGAR TODOS OS REGISTROS
            self.regAteFavoritosBuscarFormaContato(callback, registros, Number(apiSuccess.countAll))
          }, self.regAteFavoritosSetaStatusGeral)
        } else {
          // ADICIONA O REGISTRO INICIAL
          registros.unshift({ id: '', nome: 'Sem contato', icone: '' })

          // SETA OS REGISTROS RECEBIDOS
          self.formaConOptions = registros

          // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
          if (callback !== null) {
            callback()
          }
        }
      },
      regAteFavoritosBuscarRegistros: function (callback) {
        var self = this

        // INICIA O QUERYGET
        var queryGet = { type: 'list', return: 'arrayGroupByField', field: { id: null } }

        // SETA O WHERE
        queryGet.where = { aAnd: [ { f: 'id_contato', o: '=', v: self.cpntId }, { f: 'status', o: '=', v: '1' }, { f: 'id_reg_ate_pai', o: 'isNull' } ] }

        // REALIZA A BUSCA DOS REGISTROS SOLICITADOS
        self.$store.state.comunicaAPI('/reg-atendimento/get/', 'GET', queryGet, function (apiSuccess) {
          if ([ '', null, undefined ].indexOf(apiSuccess.data) !== -1 || [ null, undefined ].indexOf(apiSuccess.data.id) !== -1) {
            self.regAteFavoritosSetaStatusGeral({ loc: 'WEB', code: 500, message: 'Erro ao identificar assuntos do contato.' })
          } else {
            // PEGA OS IDS RECEBIDOS E CONVERTE EM VETOR
            var ids = apiSuccess.data.id.split(',')

            // CHAMA A FUNÇÃO PARA BUSCAR AS MENSAGENS DE CADA ASSUNTO
            self.regAteFavoritosBuscarMensagens(ids, callback)
          }
        }, self.regAteFavoritosSetaStatusGeral)
      },
      regAteFavoritosBuscarMensagens: function (ids, callback, qtde = 300, ini = null, fim = null, registros = [], busca = []) {
        var self = this

        // SETA OS DADOS QUE SERÁ BUSCADO
        if (busca.length === 0) {
          if (ini === null && fim === null) {
            ini = 0
            fim = qtde
          } else if (ids.length > (ini + qtde)) {
            ini += qtde
            fim += qtde
          } else {
            ini = null
            fim = null
          }
        }

        if (ini !== null && fim !== null) {
          // INICIA O QUERYGET
          var queryGet = { type: 'list', limit: { row: busca.length, qty: 1000 }, order: { last_at: 'asc' } }

          // SETA O WHERE
          queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'id_usu_favorito', o: 'isNotNull' }, { f: 'id_reg_ate_pai', o: 'in', v: ids.slice(ini, fim).join(',') } ] }

          // SETA O FILTRO DO USUARIO
          if ([ '', null, undefined ].indexOf(self.filtros.usuario.value) === -1) {
            queryGet.where.aAnd.push({ f: 'last_user', o: '=', v: self.filtros.usuario.value })
          }

          // REALIZA A BUSCA DOS REGISTROS SOLICITADOS
          self.$store.state.comunicaAPI('/reg-atendimento/get/', 'GET', queryGet, function (apiSuccess) {
            // JUNTA OS VALORES RECEBIDOS
            busca = busca.concat(apiSuccess.data)

            // VERIFICA SE RETORNO TODOS OS IDS SOLICITADOS
            switch (Number(apiSuccess.countAll) > busca.length) {
              case true:
                self.regAteFavoritosBuscarMensagens(ids, callback, qtde, ini, fim, registros, busca)
                break

              default:
                // JUNTA OS VALORES RECEBIDOS
                registros = registros.concat(busca)

                // CHAMA A FUNÇÃO PARA CONTINUAR AS BUSCAS
                self.regAteFavoritosBuscarMensagens(ids, callback, qtde, ini, fim, registros, [])
                break
            }
          }, self.regAteFavoritosSetaStatusGeral)
        } else {
          this.regAteFavoritosTratarValores(registros, callback)
        }
      },
      regAteFavoritosTratarValores: function (dados, callback = null) {
        // INICIA O VETOR QUE VAI RECEBER OS DADOS
        var vetor = {}

        var ids = []

        // IMPORTA BIBLIOTECA DEPENDENTE
        var moment = require('moment')

        for (var key in dados) {
          // ADICIONA OS IDS
          ids.push(dados[key].id)

          // FORMATA A DATA RECEBIDA
          dados[key].data_hora = moment(dados[key].last_at, 'YYYY/MM/DD HH:mm:ss')
          
          // FORMATA OS VALORES
          dados[key].last_at_ptbr = dados[key].data_hora.format('DD/MM/YYYY HH:mm:ss')
          dados[key].last_at_ptbr = dados[key].last_at_ptbr.split(' ').join(' às ')

          // CONVERTE A DATA PARA TIME
          dados[key].time = moment(dados[key].data_hora.format('DD/MM/YYYY'), 'DD/MM/YYYY').unix()
          
          // INICIA A DATA SE ELA NÃO EXISTIR
          if ([ '', null, undefined ].indexOf(vetor[dados[key].time]) !== -1) {
            vetor[dados[key].time] = { data: dados[key].data_hora.format('DD/MM/YYYY'), mensagens: {} }
          }

          // CRIA A CHAVE DO VETOR
          var chave = '_' + dados[key].id
          
          // VERIFICA SE A MENSAGEM JÁ EXISTE
          if ([ '', null, undefined ].indexOf(vetor[dados[key].time].mensagens[chave]) !== -1) {
            vetor[dados[key].time].mensagens[chave] = {}
          }

          // ADICIONA A MENSAGEM AO VETOR
          vetor[dados[key].time].mensagens[chave] = dados[key]
        }

        // SETA OS DADOS RECEBIDOS
        this.registros = vetor
        
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // BUSCA OS DADOS DE ARQUIVOS EXISTES
        this.regAteFavoritosBuscarAnexosDaConversa(ids)

        // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
        if (callback !== null) {
          callback()
        }
      },
      regAteFavoritosBuscarAnexosDaConversa: function (ids, qtde = 300, ini = null, fim = null, retornos = []) {
        var self = this

        if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 30 ], null, null, null, null, null, false) === true) {
          // SETA OS DADOS QUE SERÁ BUSCADO
          if (ini === null && fim === null) {
            ini = 0
            fim = qtde
          } else if (ids.length > (ini + qtde)) {
            ini += qtde
            fim += qtde
          } else {
            ini = null
            fim = null
          }
  
          if (ini !== null && fim !== null) {
            // INICIA O QUERYGET
            var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }
  
            // SETA OS FILDS QUE DESEJA 
            queryGet.field = { id: null, id_reg_atendimento: null, filename: { a: 'name' }, ext: null, size_bytes_thumbnail: null }
            
            // SETA O WHERE
            queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }
  
            // MONTA A PESQUINA NA API
            queryGet.where.aAnd.push({ f: 'id_reg_atendimento', o: 'in', v: ids.slice(ini, fim).join() })
  
            // FAZ A BUSCA NA API
            self.$store.state.comunicaAPI('/arm-arquivo/get/', 'GET', queryGet, function (apiSuccess) {
              // JUNTA OS VALORES RECEBIDOS NO VETOR
              retornos = retornos.concat(apiSuccess.data)
  
              // FAZ A QUEBRA O VALOR RECEBIDO E CHAMA A FUNÇÃO PARA BUSCAR
              self.regAteFavoritosBuscarAnexosDaConversa(ids, qtde, ini, fim, retornos)
            }, self.regAteFavoritosSetaStatusGeral)
          } else {
            // INICIA O VETOR PARA ADICONAR O IDS
            var thumbnailIds = []

            // TRATA CADA ARQUIVO
            for (var indexF in retornos) {
              if ([ '', null, undefined ].indexOf(retornos[indexF].size_bytes_thumbnail) === -1 && Number(retornos[indexF].size_bytes_thumbnail) > 0) {
                thumbnailIds.push(retornos[indexF].id)
              }
            }

            // CHAMA A FUNÇÃO PARA FINALIZAR SE NÃO TIVER THUMBNAIL
            self.regAteFavoritosBuscarConteudoArquivos('thumbnail_b64', thumbnailIds, function (vetor) {
              // ADICIONA AS INFORMAÇOES RECEBIDAS
              for (var key in vetor) {
                // PEGA O INDEX QUE DEVE ADICIONAR
                var index = retornos.findIndex(item => item.id === vetor[key].id)

                // JUNTA OS VALORES
                if (index !== -1) {
                  retornos[index] = Object.assign(retornos[index], vetor[key])
                }
              }
              
              // CHAMA A FUNÇÃO PARA FINALIZAR
              self.regAteFavoritosBuscarAnexosDaConversaFinalizar(retornos)
            })
          }
        }
      },
      regAteFavoritosBuscarConteudoArquivos: function (tipo, ids, callback, qtde = 300, ini = null, fim = null, retornos = []) {
        var self = this

        // SETA OS DADOS QUE SERÁ BUSCADO
        if (ini === null && fim === null) {
          ini = 0
          fim = qtde
        } else if (ids.length > (ini + qtde)) {
          ini += qtde
          fim += qtde
        } else {
          ini = null
          fim = null
        }

        if (ini !== null && fim !== null) {
          // PEGA OS IDS QUE DEVE BUSCAR
          var busca = ids.slice(ini, fim)

          // INICIA O QUERYGET
          var queryGet = { lot: [] }
          
          // ADICIONA O VALOR AO VETOR
          for (var key in busca) {
            queryGet.lot.push({ id: busca[key], tipo: [ tipo ] })
          }

          // FAZ A BUSCA NA API
          self.$store.state.comunicaAPI('/arm-arquivo/arquivo/get/', 'GET', queryGet, function (apiSuccess) {
            // ADICIONA OS VALORES NO VETOR
            for (var index in apiSuccess.lot) {
              switch (apiSuccess.lot[index].code) {
                case '200':
                  retornos.push(apiSuccess.lot[index].data)
                  break
                
                default:
                  self.$store.state.msgWarn('API [' + apiSuccess.lot[index].code + ']: ' + apiSuccess.lot[index].message, 'danger')
                  break
              }
            }

            // FAZ A QUEBRA O VALOR RECEBIDO E CHAMA A FUNÇÃO PARA BUSCAR
            self.regAteFavoritosBuscarConteudoArquivos(tipo, ids, callback, qtde, ini, fim, retornos)
          }, self.regAteFavoritosSetaStatusGeral)
        } else {
          callback(retornos)
        }
      },
      regAteFavoritosBuscarAnexosDaConversaFinalizar: function (arquivos) {
        // TRATA CADA ARQUIVO
        for (var indexF in arquivos) {
          // PEGA O ID DA MENSAGEM
          var indexM = '_' + arquivos[indexF].id_reg_atendimento

          for (var indexD in this.registros) {
            if ([ '', null, undefined ].indexOf(this.registros[indexD].mensagens[indexM]) === -1) {
              // INICIA O VETOR SE ELE NÃO EXISTIR
              if ([ '', null, undefined ].indexOf(this.registros[indexD].mensagens[indexM].files) !== -1) {
                this.registros[indexD].mensagens[indexM].files = {}
              }

              // PEGA O ID DO ARQUIVO
              var indexA = arquivos[indexF].id

              // SETA AS CHAVES QUE DEVE UTILIZAR PARA ENCONTRAR O ARQUIVO
              arquivos[indexF].chave = indexD + '--' +  indexM + '--' + indexA

              // SETA O ARQUIVO NO VETOR
              this.registros[indexD].mensagens[indexM].files[indexA] = arquivos[indexF]
            }
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      regAteFavoritosFinalizar: function (callback = null) {
        // LIMPA O STATUS DA TELA, PARA CARREGAMENTO
        this.regAteFavoritosSetaStatusGeral('')

        // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
        if (callback !== null) {
          callback()
        }
      },
      regAteFavoritosAbrirMensagem: function (indexD, indexM) {
        // FORMTA A CHAVE
        indexM = '_' + indexM

        // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA ABRIR O CHAT
        var formData = { tipo: 'abrir', contato: this.cpntId, favorito: true }

        // SETA O ID DO ASSUNTO QUE ESTÁ SENDO TRATADO
        formData.assunto = this.registros[indexD].mensagens[indexM].id_reg_ate_pai

        // SETA O ID DA MENSAGEM
        formData.mensagem = this.registros[indexD].mensagens[indexM].id

        // SETA O REGISTRO DE ATENDIMENTO
        this.$store.commit('SET_REG_ATENDIMENTO', formData)

        // CHAMA A FUNÇÃO PARA FECHAR O FORMULARIO
        this.cpntFecharFormulario(false)
      }
    }
  }
</script>
